import { Box, Button, Card, Flex, Heading, TextField } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { useSearchParams } from 'react-router-dom';
import { useResumeManager } from '../resume-manager.provider';

const ResumeManagerFiltersView = () => {
   const resumeManager = useResumeManager();
   const [searchParams, setSearchParams] = useSearchParams();

   const submitSearch = () => {
      if (searchParams.get('page') === '1') {
         resumeManager.submitSearch();
         return;
      }

      const nextSearchParams = new URLSearchParams(searchParams);
      nextSearchParams.set('page', '1');
      setSearchParams(nextSearchParams, { replace: true });
   };

   return (
      <Card m="3" className="resume-manager-filters">
         <Flex direction="column" gap="2" width="100%">
            <Heading as="h4" weight="medium" color="gray">
               Filters
            </Heading>

            <Flex gap="3" align="end" wrap="wrap">
               <Box minWidth="300px" width="100%" maxWidth="420px">
                  <TextField.Root
                     placeholder="Search by Resume ID or Resume Name"
                     size="3"
                     color="blue"
                     autoComplete="off"
                     value={resumeManager.searchStr}
                     onChange={(e) => {
                        resumeManager.onSearchChange(e.target.value);
                     }}
                     onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                           submitSearch();
                        }
                     }}
                  />
               </Box>

               <Button
                  size="3"
                  onClick={() => {
                     submitSearch();
                  }}
               >
                  Search
               </Button>
            </Flex>
         </Flex>
      </Card>
   );
};

export const ResumeManagerFilters = observer(ResumeManagerFiltersView);
